import styled from 'styled-components'
import {
	TituloH1 as TituloPrincipal,
	Descricao
} from '../../../../components/TituloSorriso/styles'

export const Container = styled.div`
  min-height: 350px;
  display: flex;
  padding-top: 70px;
  align-items: flex-start;
  background: linear-gradient(87deg, #CC082E -11.13%, #333B8E 96.71%);

  @media(max-width: 1024px) {
    flex-direction: column;
    flex-flow: column-reverse;

    align-items: center;
    padding: 70px !important;
    gap: 15px;
  }

  @media(max-width: 767px) {
    align-items: center;
    padding: 30px 60px 60px 60px !important;
    gap: 15px;

    background: linear-gradient(180deg, #CC082E -11.13%, #333B8E 96.71%);
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const ButtonWrapper = styled.div`
  max-width: max-content;
`

export const Title = styled(TituloPrincipal)`
  color: ${(props) => props.color};
  text-align: left !important;
  line-height: 45px;
  font-size: 32px;
  font-weight: 600;
  padding-right: 165px;
  padding-bottom: 16px;
  padding-top: 0;

  @media(max-width: 767px) {
    padding-right: 0;
		font-size: 24px;
    font-weight: 500;
    line-height: 33px;
  }
`;

export const Text = styled(Descricao)``;

export const Image = styled.img`
  position: relative;
  flex: 1;
  top: -17px;

  @media(max-width: 767px) {
    width: 100%;
    top: 0;
  }
`;


export const Button = styled.button`
  display: flex;
  padding: 17px 32px;
  justify-content: center;
  align-items: center;

  font-family: "Work Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  border: 1px solid transparent;
  color: ${({ color }) => color};
  border-radius: 100px;
  background: ${({ background }) => background};
  transition: all 0.5s;

  &:hover {
    border-color: #fff;
    color: #fff;
    background: transparent;
  }
`